export enum ModerationType {
  IMAGE = 'image',
  CONTENT = 'content',
  REPUBLISH = 'republish',
  CHANGE_OWNERSHIP = 'change_ownership',
  CHANGE_GEAR = 'change_gear',
}

export const MODERATOR_IDS =
  process.env.NODE_ENV === 'production'
    ? [
        '0f9804a4-488f-4293-97fb-f20415ecc599',
        '5e2d2e07-5604-4a79-b3c7-72451bcc19fd',
        'eb5a4624-5a78-4d09-a173-d6ff4789a781',
        '84e154a6-e8d9-437c-a334-1bc4cf046ccf',
      ]
    : [
      '0f9804a4-488f-4293-97fb-f20415ecc599',
      '5e2d2e07-5604-4a79-b3c7-72451bcc19fd',
      'eb5a4624-5a78-4d09-a173-d6ff4789a781',
      '84e154a6-e8d9-437c-a334-1bc4cf046ccf',
    ];

export const isModerator = (userId: string) => {
  return MODERATOR_IDS.includes(userId);
};
